
import React from 'react';

interface TeamMember {
  image: string;
  name: string;
  role: string;
  bio: string;
}

const TeamSection = () => {
  const teamMembers: TeamMember[] = [
    {
      image: "/lovable-uploads/ffff2be3-a5ba-401a-a463-96f91ab093e2.png",
      name: "Lars Heimsath",
      role: "Founder & CEO",
      bio: "Former AI research lead with 15+ years in machine learning and neural networks."
    },
    {
      image: "/lovable-uploads/e5cea6f6-16e1-4a7b-b997-8b5bb851d1b2.png",
      name: "Lars Heimsath",
      role: "Chief Content Officer",
      bio: "PhD in Computational Linguistics with expertise in NLP and content strategy."
    },
    {
      image: "/lovable-uploads/ecfcf681-465c-4221-8891-4d0778561778.png",
      name: "Lars Heimsath",
      role: "CTO",
      bio: "Former tech lead at a major AI lab with expertise in computer vision and reinforcement learning."
    }
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Our Team</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the experts behind AI Nexus
          </p>
        </div>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center">
              <div className="relative mx-auto h-40 w-40 rounded-full overflow-hidden mb-4">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-lg font-medium text-gray-900">{member.name}</h3>
              <p className="text-ai-indigo font-medium">{member.role}</p>
              <p className="mt-2 text-gray-500">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;

